// Детали отдельного матча (ui-spec.md §3 «match-detail»). Сейчас — заглушка
// с шапкой результата и метаданными; реплей-доска и пошаговый просмотр —
// в следующих этапах (нужен сетевой движок и сохранённые matches на сервере).

import { useParams } from 'react-router-dom';
import { ScreenLayout } from '../components/ScreenLayout';

export function MatchDetailScreen() {
  const { id } = useParams<{ id: string }>();
  return (
    <ScreenLayout title="МАТЧ" backTo="/archive" backLabel="архив">
      <div style={{
        background: 'linear-gradient(135deg, rgba(156,255,61,0.10) 0%, var(--bg-2) 100%)',
        padding: '14px',
        boxShadow: 'inset 0 0 0 0.5px var(--neon-li)',
        clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span className="cd" style={{ color: 'var(--neon-li)', fontSize: 16, letterSpacing: '0.12em' }}>
            ► ПОБЕДА
          </span>
          <span className="cm" style={{ color: 'var(--t-md)', fontSize: 11 }}>
            7 МИН 14 С
          </span>
        </div>
        <div className="cm" style={{ color: 'var(--t-lo)', fontSize: 10, marginTop: 6 }}>
          06/05/26 · 22:30 · РЕЙТ · +30 поинтов · +13 ◆
        </div>
      </div>

      <div style={{
        background: 'var(--bg-2)',
        padding: '20px',
        boxShadow: 'inset 0 0 0 0.5px var(--line)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10
      }}>
        <div className="cd" style={{ color: 'var(--neon-am)', fontSize: 11, letterSpacing: '0.15em' }}>
          ФИНАЛЬНЫЙ РАСКЛАД
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 4,
          width: '100%',
          maxWidth: 280,
          aspectRatio: '4 / 4'
        }}>
          {/* 4x4 = 2 поля × 2 линии × 4 слота. Декоративный mock. */}
          {Array.from({ length: 16 }).map((_, i) => {
            const isUnit = [1, 3, 7, 8, 10].includes(i);
            const factionColor = i === 1 || i === 8 || i === 10 ? 'var(--deus)' : 'var(--syn)';
            return (
              <div
                key={i}
                style={{
                  background: 'var(--bg-0)',
                  border: '1px solid var(--line)',
                  borderRadius: 2,
                  aspectRatio: '1',
                  boxShadow: isUnit ? `inset 0 0 0 1px ${factionColor}` : 'none'
                }}
              />
            );
          })}
        </div>
        <div className="cb" style={{ color: 'var(--t-md)', fontSize: 11, maxWidth: 280, textAlign: 'center', lineHeight: 1.5 }}>
          У тебя осталось 5 юнитов, у противника — 0. Финальный удар:
          Танаки → Бишор в Ф4 (4 урона по 2 hp Героя).
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
          <Stat label="Урона Героем" value="14" />
          <Stat label="Призвано" value="9" />
          <Stat label="Действий" value="3" />
        </div>
        <div className="cm" style={{ color: 'var(--t-mute)', fontSize: 9 }}>
          ID матча: {id}
        </div>
      </div>

      <div style={{
        background: 'var(--bg-2)',
        padding: '10px 12px',
        boxShadow: 'inset 0 0 0 0.5px var(--line)'
      }}>
        <div className="cd" style={{ color: 'var(--neon-cy)', fontSize: 10, letterSpacing: '0.1em', marginBottom: 8 }}>
          ЛОГ ОПЕРАЦИИ
        </div>
        <LogEntry turn="Х5" you="Танаки нанёс 3 урона юниту Скил" />
        <LogEntry turn="Х5" opp="Скил Бишор контратаковал, нанёс 2 урона" />
        <LogEntry turn="Х5" you="Сыграна карта Действие «Перехват»" />
        <LogEntry turn="Х6" you="Танаки атаковал Героя, 4 урона" />
        <LogEntry turn="Х6" opp="Скил Бишор использовал активку: -1 HP себе, +3 atk юниту" />
        <LogEntry turn="Х7" you="Поставлен юнит «Аналитик Деуса» на 1-ю линию" />
      </div>
    </ScreenLayout>
  );
}

function LogEntry({ turn, you, opp }: { turn: string; you?: string; opp?: string }) {
  return (
    <div style={{ display: 'flex', gap: 8, fontSize: 11, marginBottom: 3 }}>
      <span className="cm" style={{ color: 'var(--t-mute)', flexShrink: 0 }}>{turn} ·</span>
      {you && <span style={{ color: 'var(--neon-cy)' }}>{you}</span>}
      {opp && <span style={{ color: 'var(--neon-mg)' }}>{opp}</span>}
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <span style={{ color: 'var(--neon-cy)', fontSize: 16, fontWeight: 700 }}>{value}</span>
      <span style={{ color: 'var(--t-lo)', fontSize: 9, letterSpacing: 0.5, textTransform: 'uppercase' }}>{label}</span>
    </div>
  );
}
